module.exports = __webpack_public_path__ + "8bd27fe9f42d7d0de8a3194c755fddd1.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-LightItalic.woff2
// module id = 1800
// module chunks = 1